export default "__VITE_ASSET__D1lSo8FD__"